var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 2H11V1a.5.5 0 0 0-1 0v1H6V1a.5.5 0 0 0-1 0v1H3.5A1.5 1.5 0 0 0 2 3.5v9A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 12.5 2m.5 10.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V6h10zM13 5H3V3.5a.5.5 0 0 1 .5-.5H5v.5a.5.5 0 0 0 1 0V3h4v.5a.5.5 0 0 0 1 0V3h1.5a.5.5 0 0 1 .5.5z"
  })));
};
export default SvgCalendar;